import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, X } from 'lucide-react';
import { thematicContent } from '../data/thematicContent';
import RelatedPages from '../components/RelatedPages';
import { relatedPagesMap } from '../data/relatedPages';
import FAQ from '../components/FAQ';
import { faqMap } from '../data/faqContent';
import SEO from '../components/SEO';

const SOPKAlimentation = () => {
  const pageData = thematicContent.sopkAlimentation;

  return (
    <div style={{ marginTop: '100px' }}>
      <SEO
        title={pageData.meta.title}
        description={pageData.meta.description}
        keywords={pageData.meta.keywords}
        url="https://nutricentreriviera.ch/sopk-alimentation"
      />
      <section style={{ background: 'var(--gradient-hero)', padding: '4rem 0', textAlign: 'center' }}>
        <div className="container">
          <h1 className="heading-hero" style={{ marginBottom: '1.5rem' }}>{pageData.h1}</h1>
          <p className="heading-subtitle" style={{ maxWidth: '900px', margin: '0 auto 2rem' }}>{pageData.intro}</p>
          <a href="https://www.onedoc.ch/fr/therapeute-en-nutrition-mco/vevey/pcyv4/zara-nawid" target="_blank" rel="noopener noreferrer" className="btn-primary">Prendre rendez-vous<ArrowRight size={20} /></a>
        </div>
      </section>

      <section className="section" style={{ background: 'white' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem' }}>{pageData.sections[0].title}</h2>
          <p className="body-large" style={{ marginBottom: '1.5rem' }}>{pageData.sections[0].content}</p>
          
          <div style={{ background: 'var(--bg-page)', borderRadius: '1rem', padding: '2rem', marginBottom: '4rem' }}>
            <h3 className="heading-3" style={{ marginBottom: '1rem' }}>Symptômes du SOPK :</h3>
            <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '0.75rem' }}>
              {pageData.sections[0].symptoms.map((symptom, i) => (
                <li key={i} style={{ display: 'flex', gap: '0.5rem' }}>
                  <CheckCircle2 size={18} style={{ color: 'var(--accent-primary)', flexShrink: 0, marginTop: '0.2rem' }} />
                  <span className="body-medium">{symptom}</span>
                </li>
              ))}
            </ul>
          </div>

          <h2 className="heading-2" style={{ marginBottom: '2rem' }}>{pageData.sections[1].title}</h2>
          {pageData.sections[1].reasons.map((reason, i) => (
            <div key={i} style={{ marginBottom: '2rem', background: 'var(--bg-page)', borderRadius: '1rem', padding: '1.5rem', borderLeft: '4px solid var(--accent-primary)' }}>
              <h3 className="heading-3" style={{ marginBottom: '0.75rem' }}>{reason.title}</h3>
              <p className="body-medium">{reason.content}</p>
            </div>
          ))}

          <h2 className="heading-2" style={{ marginBottom: '2rem', marginTop: '4rem' }}>Que manger avec le SOPK ?</h2>
          <div className="two-col-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', marginBottom: '4rem' }}>
            <div style={{ background: '#E8F5F0', borderRadius: '1rem', padding: '2rem' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem', color: 'var(--accent-primary)' }}>Aliments à privilégier</h3>
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {pageData.sections[3].toEat.map((food, i) => (
                  <li key={i} style={{ display: 'flex', gap: '0.5rem' }}>
                    <CheckCircle2 size={18} style={{ color: 'var(--accent-primary)', flexShrink: 0, marginTop: '0.2rem' }} />
                    <span className="body-medium">{food}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ background: '#FEF2F2', borderRadius: '1rem', padding: '2rem' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem', color: '#DC2626' }}>Aliments à limiter</h3>
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {pageData.sections[3].toLimit.map((food, i) => (
                  <li key={i} style={{ display: 'flex', gap: '0.5rem' }}>
                    <X size={18} style={{ color: '#DC2626', flexShrink: 0, marginTop: '0.2rem' }} />
                    <span className="body-medium">{food}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div style={{ background: 'var(--accent-primary-light)', borderRadius: '1rem', padding: '3rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '2rem' }}>Résultats attendus</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
              {pageData.sections[4].results.map((result, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--accent-primary)', flexShrink: 0 }} />
                  <span className="body-medium">{result}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <FAQ items={faqMap['sopk-alimentation']} />

      <RelatedPages items={relatedPagesMap['sopk-alimentation']} />

      <section style={{ background: 'var(--accent-primary)', color: 'white', padding: '5rem 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '1rem' }}>{pageData.cta.title}</h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.95, margin: '0 auto 2.5rem' }}>{pageData.cta.text}</p>
          <a href="https://www.onedoc.ch/fr/therapeute-en-nutrition-mco/vevey/pcyv4/zara-nawid" target="_blank" rel="noopener noreferrer" className="btn-primary" style={{ background: 'white', color: 'var(--accent-primary)' }}>{pageData.cta.button}<ArrowRight size={20} /></a>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          section > div > div[style*="grid-template-columns: 1fr 1fr"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default SOPKAlimentation;
